// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { PortalBaseEntity } from '../portal-base-entity';
import { BankAccount } from './bank-account';
import { BankAccountFeed } from './bank-account-feed';
import { Job } from './job';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Practice extends PortalBaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  practiceId!: number;
  blacklisted!: boolean;
  claimFlags!: number;
  createdAt!: Date;
  createdBy!: string;
  deleted!: boolean;
  discriminator!: string;
  domains?: string;
  hasActiveLicense!: boolean;
  licenseExpiresAt!: Date;
  practiceDesc?: string;
  practiceGuid?: string;
  practiceName?: string;
  practiceShortName?: string;
  updatedAt!: Date;
  updatedBy!: string;
  version!: any;
  bankAccountFeeds!: BankAccountFeed[];
  bankAccounts!: BankAccount[];
  jobs!: Job[];
}

